import React from "react";
import { EmptyState } from "@/components/admin/AdminBits";

export function ClientsPanel({ clients }) {
  if (clients.length === 0) {
    return (
      <div data-testid="clients-panel" className="border border-slate-200 bg-white">
        <EmptyState label="No registered clients yet." />
      </div>
    );
  }
  return (
    <div data-testid="clients-panel" className="border border-slate-200 bg-white">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-[0.25em] text-slate-500 border-b border-slate-200">
              <th className="px-4 py-3">Joined</th>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Company</th>
              <th className="px-4 py-3">Contact</th>
              <th className="px-4 py-3">Location</th>
              <th className="px-4 py-3">Business Type</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c) => (
              <tr key={c.id} data-testid={`client-row-${c.id}`} className="border-b border-slate-200 hover:bg-slate-50">
                <td className="px-4 py-4 text-slate-500 text-xs">{new Date(c.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-4">
                  <div className="font-heading font-bold text-slate-900">{c.name}</div>
                  <div className="text-xs text-slate-500">{c.job_title || "—"}</div>
                </td>
                <td className="px-4 py-4">
                  <div className="text-slate-900">{c.company_name}</div>
                  <div className="text-xs text-slate-500">{c.website || ""}</div>
                </td>
                <td className="px-4 py-4 text-slate-700 text-xs">
                  <div>{c.email}</div>
                  <div>{c.phone}</div>
                </td>
                <td className="px-4 py-4 text-slate-700 text-xs">
                  {[c.city, c.state, c.zip_code].filter(Boolean).join(", ") || "—"}
                </td>
                <td className="px-4 py-4 text-slate-700 text-xs">{c.business_type || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
